import ExamCoordinator from "../views/schooladmin/ExamCoordinator";
import ExamCoordinatorAddEdit from "../views/schooladmin/ExamCoordinatorAddEdit";

export default [
	{
		path: "/schooladmin/exam_coordinator",
		components: {
			content: ExamCoordinator
		}
	},
	{
		path: "/schooladmin/exam_coordinator/new",
		components: {
			content: ExamCoordinatorAddEdit
		}
	},
	{
		path: "/schooladmin/exam_coordinator/update/:id",
		components: {
			content: ExamCoordinatorAddEdit
		},
		props: {
			content: true
		}
	}
];
